import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { IAgent, IPassword } from '../../models';
import { Constants } from '@config/constants';

@Injectable({ providedIn: 'root' })
export class AgentService {
  public readonly API_URL = this.constants.AGENT_USER_ENDPOINT;
  public readonly AGENT_PASSWORD_ENDPOINT =
    this.constants.AGENT_PASSWORD_ENDPOINT;

  constructor(
    private http: HttpClient,
    private readonly constants: Constants
  ) {}

  getIAgents(): Observable<IAgent[]> {
    return this.http.get<IAgent[]>(this.API_URL);
  }

  addIAgentGenerateUsername(user: IAgent): Observable<IAgent> {
    return this.http.post<IAgent>(this.API_URL + '/generatedUsername', user);
  }

  deleteIAgent(id: number): Observable<IAgent> {
    const url = `${this.API_URL}/${id}`;
    return this.http.delete<IAgent>(url);
  }

  updateIAgent(agent: IAgent): Observable<any> {
    const url = `${this.API_URL}/${agent.id}`;
    return this.http.patch(url, agent);
  }

  generatePwd(id: number): Observable<IPassword> {
    const url = `${this.AGENT_PASSWORD_ENDPOINT}/${id}`;
    return this.http.patch<IPassword>(url, null);
  }

  existsAgentByMachineId(agents: IAgent[], machineId: number, currentAgentId?: number): boolean {
    return agents.some(
      (agent) => {
        if (!currentAgentId && agent.machineId === machineId) { return true; } //Add case
        if (currentAgentId && currentAgentId !== agent.id && agent.machineId === machineId) { return true; } //Edit case
        return false;
      }
    );
  }
}
